import { getId } from "helpers/functions";
import {
  DELETE_CONTACT,
  DELETE_CONTACT_FAILURE,
  DELETE_CONTACT_SUCCESS,
  GET_CONTACTS,
  GET_CONTACTS_FAILURE,
  GET_CONTACTS_SUCCESS,
  GET_SINGLE_CONTACT,
  GET_SINGLE_CONTACT_FAILURE,
  GET_SINGLE_CONTACT_SUCCESS,
} from "./actionTypes";

const initialState = {
  contacts: [],
  loading: false,
  error: "",
  singleContact: {},
};

const contacts = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONTACTS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_CONTACTS_SUCCESS:
      state = {
        ...state,
        loading: false,
        contacts: action.payload.contacts,
      };
      break;
    case GET_CONTACTS_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    case GET_SINGLE_CONTACT:
      state = {
        ...state,
        loading: true,
      };
      break;

    case GET_SINGLE_CONTACT_SUCCESS:
      state = {
        ...state,
        loading: false,
        singleContact: action.payload.contact,
      };
      break;

    case GET_SINGLE_CONTACT_FAILURE:
      state = {
        ...state,
        loading: false,
        error: action.payload,
        singleContact: {},
      };
      break;

    case DELETE_CONTACT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case DELETE_CONTACT_SUCCESS:
      state = {
        ...state,
        loading: false,
        contacts: state.contacts.filter(
          (contact) => getId(contact) !== action.payload?.id
        ),
      };
      break;
    case DELETE_CONTACT_FAILURE:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default contacts;
